import { Image } from 'shared/components/Gallery/Gallery.types';

export const generatePrimaryImageSrcset = (
    primaryImage: Image[] | undefined
): string => {
    if (!primaryImage) {
        primaryImage = [];
    }
    return primaryImage
        .map((image) => `${image.src} ${image.width}w`)
        .join(', ');
};
